import {registerGraph, mergeGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('environmentalGraph', environmentalGraph);

/* @ngInject */
function environmentalGraph(GraphService, locale, defaultGraph) {
    const GraphColors = GraphService.colors;
    return mergeGraph(defaultGraph(), {
        options: {
            colors: [GraphColors.red, GraphColors.blue, GraphColors.orange],
            chart: {
                type: 'column'
            },
            plotOptions: {
                series: {
                    stacking: 'normal',
                    pointPadding: 0,
                    groupPadding: 0.02,
                    borderWidth: 0
                }
            },
            tooltip: GraphService.getTooltipFormatterWithTotal([0, 1, 2], locale.getString('graph.kwh'))
        },
        xAxis: {
            type: 'datetime',
            labels: {formatter: GraphService.datetimeLabeler()},
            gridLineColor: '#E6E5E1',
            gridLineWidth: 16,
            minorGridLineColor: '#E6E5E1',
            minorGridLineWidth: 16,
            minorTickLength: 0,
            minorTickInterval: 'auto'
        },
        yAxis: [
            {
                title: {
                    text: locale.getString('graph.kwh'),
                    align: 'high',
                    y: -20,
                    rotation: 0,
                    offset: 5
                },
                gridLineWidth: 0,
                showFirstLabel: true
            }
        ],
        series: [
            {
                name: locale.getString('graph.to_grid'),
                tooltip: {
                    valueSuffix: ' ' + locale.getString('graph.kwh'),
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter()
                },
                states: {
                    hover: {
                        color: GraphColors.lightRed
                    }
                },
                visible: false,
                data: []
            },
            {
                name: locale.getString('graph.to_battery'),
                tooltip: {
                    valueSuffix: ' ' + locale.getString('graph.kwh'),
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter()
                },
                states: {
                    hover: {
                        color: GraphColors.lightBlue
                    }
                },
                visible: false,
                data: []
            },
            {
                name: locale.getString('graph.direct_use'),
                tooltip: {
                    valueSuffix: ' ' + locale.getString('graph.kwh'),
                    valueDecimals: 2,
                    pointFormatter: GraphService.getTablePointFormatter()
                },
                states: {
                    hover: {
                        color: GraphColors.lightOrange
                    }
                },
                visible: false,
                data: []
            }
        ]
    });
}
